import { useEffect, useState, useRef } from 'react';
// import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const breakpoints = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1400px)'
};
const Hero = () => {
    // const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [rotation] = useState(0);
    const [isLargeScreen, setIsLargeScreen] = useState(false);
    // const [isExtraSmallScreen, setIsExtraSmallScreen] = useState(false);
    // const any = isSmallScreen ? isLargeScreen : isExtraSmallScreen;
    const heroRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const [animationDuration, setAnimationDuration] = useState(30); // seconds
    useEffect(() => {
        // const mediaQueryListExtraSmall = window.matchMedia(breakpoints.xs);
        const mediaQueryList = window.matchMedia(breakpoints.sm);
        const mediaQueryListLarge = window.matchMedia(breakpoints.lg);

        // const handleMediaQueryChange = (event: MediaQueryListEvent) => {
        //   setIsSmallScreen(event.matches);
        // };

        // const handleMediaQueryChangeExtraSmall = (event: MediaQueryListEvent) => {
        //   setIsExtraSmallScreen(event.matches);
        // }

        const handleMediaQueryChangeLarge = (event: MediaQueryListEvent) => {
            setIsLargeScreen(event.matches);
        };

        // mediaQueryList.addEventListener('change', handleMediaQueryChange);
        mediaQueryListLarge.addEventListener('change', handleMediaQueryChangeLarge);
        // mediaQueryListExtraSmall.addEventListener('change', handleMediaQueryChangeExtraSmall);

        // setIsExtraSmallScreen(mediaQueryListExtraSmall.matches);
        // setIsSmallScreen(mediaQueryList.matches);
        setIsLargeScreen(mediaQueryListLarge.matches);

        return () => {
            // mediaQueryList.removeEventListener('change', handleMediaQueryChange);
            // mediaQueryList.removeEventListener('change', handleMediaQueryChangeExtraSmall);
            mediaQueryList.removeEventListener('change', handleMediaQueryChangeLarge);
        };
    }, []);

    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.classList.remove('active');
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.classList.add('active');
        }
    };

    const handleMouseDown = () => {
        setAnimationDuration(5); // Spin fast while dragging
    };

    const handleMouseUp = () => {
        setAnimationDuration(30); // Return to normal speed
    };

    useEffect(() => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.addEventListener('mouseenter', handleMouseEnter);
            videoElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return () => {
            if (videoElement) {
                videoElement.removeEventListener('mouseenter', handleMouseEnter);
                videoElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, []);

    return (
        <Row className="hero section--hero section--hero-deco-small section--background" ref={heroRef}>

            <Col md={{ offset: 1, span: 5 }} sm={{ span: 6 }} className="hero__heading-col">
                <h1 className="hero__heading-col__heading">
                    Crafting personalised<br /> web solutions is our<br /> passion
                </h1>
                <h6 className="hero__heading-col__support-text">
                    Delivering seamless user experiences, robust functionality and scalable, secure solutions to meet your business needs from concept to deployment and maintenance
                </h6>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="hero__animation-col">
                <video
                    className="hero__animation-col__animation rotating active"
                    ref={videoRef}
                    id="video"
                    width={isLargeScreen ? 300 : 215}
                    src={`${process.env.PUBLIC_URL}/cropped-cube.mov`}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    playsInline
                    controls={false}
                    autoPlay
                    loop
                    muted
                    style={{
                        transform: `rotate(${rotation}deg)`,
                        animationDuration: `${animationDuration}s`
                    }}
                >
                </video>
            </Col>
        </Row>
    )
}

export default Hero;